<template>
  <div class="files">
    <div class="object-info__section-content">
      <div class="files__add-block">
        <el-input
          class="r-input"
          placeholder="http://google.com"
          @keyup.enter.native="postLink"
          v-model="link"
          size="mini"
        >
          <el-button
            slot="append"
            icon="el-icon-circle-plus-outline"
            class="files__add-btn"
            :disabled="isEmptyLink"
            size="mini"
            @click="postLink"
            :loading="isPosting"
          ></el-button>
        </el-input>
        <el-upload
          class="files__upload"
          ref="upload"
          :multiple="true"
          :drag="true"
          :data="postFileData"
          :on-success="onSuccessUpload"
          :headers="uploadHeaders"
          :action="`${url}/upload_resource`"
          :show-file-list="false"
        >
          <span class="files__upload-title">{{ $t("files:to-attach") }}</span>
        </el-upload>
      </div>
      <div class="files__container">
        <div class="files__list-block">
          <div class="files__no-data" v-if="!resources.length">
            {{ $t("files:no-files") }}
          </div>
          <ul class="files__list" v-else>
            <li v-for="item in resources" :key="item.id">
              <div
                :class="`files__item ${item.resource_type}`"
                v-if="item.resource_type === 'link'"
              >
                <a class="files__link" :href="item.name" target="_blank">
                  {{ item.name }}
                </a>
                <div class="files-controls">
                  <el-tooltip
                    :open-delay="1500"
                    :content="`${$t('files:tooltips:link-delete')}`"
                    placement="top"
                  >
                    <span
                      class="files-controls__item"
                      @click="deleteLink(item, $event)"
                    >
                      <r-icon name="trash" :size="14" />
                    </span>
                  </el-tooltip>
                </div>
              </div>
              <div
                :class="`files__item ${item.resource_type}`"
                v-if="item.resource_type === 'file'"
              >
                <a
                  class="files__file"
                  @click="clickHandler('open', item, $event)"
                  target="_blank"
                >
                  <span class="files__file-title">{{ item.name }}</span>
                </a>
                <div class="files-controls">
                  <el-tooltip
                    :open-delay="1500"
                    :content="`${$t('files:tooltips:btn-download')}`"
                    placement="top"
                  >
                    <span
                      class="files-controls__item"
                      @click="clickHandler('download', item, $event)"
                    >
                      <r-icon name="download" :size="16" />
                    </span>
                  </el-tooltip>

                  <el-tooltip
                    :open-delay="1500"
                    :content="`${$t('files:tooltips:btn-delete')}`"
                    placement="top"
                  >
                    <span
                      class="files-controls__item"
                      @click="clickHandler('delete', item, $event)"
                    >
                      <r-icon name="close-delete" :size="16" />
                    </span>
                  </el-tooltip>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import constants from "@/constants/url";
import { errorParser } from "@/utils";

export default {
  props: ["source_id", "id"],
  watch: {
    id: {
      handler: async function() {
        await this.loadResources();
      }
    }
  },
  data() {
    return {
      resources: [],
      someImage: "",
      link: "",
      file: "",
      isLoading: false,
      isPosting: false,
      url: constants.URL,
      uploadHeaders: { token: this.$store.state.auth.token }
    };
  },
  computed: {
    token() {
      return this.$store.state.auth.token;
    },
    isEmptyLink() {
      return !this.link.length;
    },
    postFileData() {
      return {
        source_id: this.source_id,
        object_id: this.id
      };
    }
  },
  methods: {
    async clickHandler(action, item, e) {
      switch (action) {
        case "open":
          this.openFile(item);
          break;
        case "download":
          this.downloadFile(item);
          break;
        case "delete":
          this.deleteFile(item, e);
          break;
      }
    },
    async openFile(item) {
      const response = await fetch(
        `${this.url}/download_resource/${item.id}?access_token=${this.token}`
      );
      const blob = await response.blob();
      const targetBlank = window.open("/");

      targetBlank.onload = () => {
        targetBlank.location = URL.createObjectURL(blob);
      };
    },
    async downloadFile(item) {
      window.open(
        `${this.url}/download_resource/${item.id}?access_token=${this.token}`
      );
    },
    async postLink() {
      if (!this.link.length) return;

      if (
        this.link.indexOf("http://") === -1 &&
        this.link.indexOf("https://") === -1
      )
        this.link = `http://${this.link}`;

      this.isPosting = true;
      const url = `upload_resource?source_id=${this.source_id}&object_id=${
        this.id
      }&body=${this.link}`;

      try {
        await this.$store.dispatch("POST_REQUEST", { url });
        await this.loadResources();
        this.link = "";
        this.isPosting = false;
      } catch (error) {
        errorParser.call(this, error);
        this.isPosting = false;
      }
    },
    async deleteFile(item, e) {
      e.stopPropagation();
      e.preventDefault();

      const { id } = item;
      const url = `objectResources/${this.source_id}/${id}`;

      try {
        await this.$store.dispatch("DELETE_REQUEST", { url });
        await this.loadResources();
        this.link = "";
        this.isPosting = false;
      } catch (error) {
        errorParser.call(this, error);
        this.isPosting = false;
      }
    },
    async deleteLink(item, e) {
      e.stopPropagation();
      e.preventDefault();

      const { id } = item;
      const url = `objectResources/${this.source_id}/${id}`;

      try {
        await this.$store.dispatch("DELETE_REQUEST", { url });
        await this.loadResources();
        this.link = "";
        this.isPosting = false;
      } catch (error) {
        errorParser.call(this, error);
        this.isPosting = false;
      }
    },
    onSuccessUpload() {
      this.loadResources();
    },
    async loadResources() {
      this.isLoading = true;
      const url = `objectResources/${this.source_id}/${this.id}`;
      const { data } = await this.$store.dispatch("REQUEST", { url });
      this.resources = data.reverse();
      this.isLoading = false;
    }
  },
  async created() {
    await this.loadResources();
  }
};
</script>

<style lang="scss">
.files {
  &__add-btn {
    &.is-disabled,
    &.is-disabled:focus,
    &.is-disabled:hover {
      background-color: transparent !important;
    }
  }
  &__no-data,
  &__loading {
    margin: 16px;
    font-size: 12px;
    color: var(--text_secondary) !important;
  }
  &__list {
    margin-top: 8px;
    padding: 8px;
    max-height: 200px;
    overflow: auto;
  }
  &__item {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: var(--border-radius);
    border: 1px solid transparent;
    background-color: var(--modal_bg) !important;
    border-color: var(--dividers_low_contrast) !important;
    text-align: center;
    margin-bottom: 5px;

    &:not(:last-child) {
      margin-bottom: 5px;
    }

    &:hover {
      opacity: 0.6;

      .files-controls {
        display: flex;
      }
    }
    a {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 5px 10px;
      width: 100%;
      text-align: left;
      overflow: hidden;
    }
    &.link {
      border-color: var(--accent_primary) !important;
      .files__link {
        color: var(--accent_primary) !important;
        font-size: 12px;
      }
    }
    &.file {
      border: 1px solid;
      cursor: pointer;
      border-color: var(--dividers_low_contrast) !important;
      .files__file {
        &-title {
          width: 100%;
          text-align: left;
          font-size: 12px;
          color: var(--text_secondary) !important;
        }
      }
    }
    .files-controls {
      display: none;
      padding: 0 12px;
      z-index: 1;
      cursor: default;
      &__item {
        padding: 4px;
        height: 16px;
        width: 16px;
        border-radius: var(--border-radius);
        cursor: pointer;
        margin-left: 4px;
        &:last-child {
          margin-right: 0;
        }
        &:hover {
          background-color: rgba(var(--accent_primary), 0.1);
        }
        &:active {
          background-color: rgba(var(--accent_primary), 0.25);
        }
      }
    }
  }
  &__title {
    font-size: 12px;
    font-weight: bold;
  }
  &__upload {
    margin-top: 10px;
    width: 100%;
    height: 24px;
    .el-upload {
      width: 100%;
      &-dragger {
        width: 100%;
        height: 28px;
        border-color: var(--field_border) !important;
        background-color: var(--field_bg) !important;

        .files__upload-title {
          color: var(--text_secondary) !important;
        }

        &:hover {
          border-color: var(--accent_primary) !important;

          .files__upload-title {
            color: var(--accent_primary) !important;
          }
        }
        &.is-dragover {
          border: 1px dashed transparent;
          border-color: var(--accent_primary) !important;
        }
      }
    }
    &-title {
      line-height: 24px;
      font-size: 12px;
      color: var(--text_secondary) !important;
    }
  }

  .el-input-group__append {
    border-color: var(--field_border) !important;
    background-color: var(--field_bg) !important;
    color: var(--text_secondary) !important;

    .el-button {
      &.is-disabled {
        border-color: transparent !important;
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "files:to-attach": "Прикрепить файл",
    "files:no-files": "Материалы отсутствуют",

    "files:tooltips:btn-download": "Скачать файл",
    "files:tooltips:btn-delete": "Удалить файл",
    "files:tooltips:link-delete": "Удалить ссылку"
  },
  "en": {
    "files:to-attach": "Attach file",
    "files:no-files": "No file",

    "files:tooltips:btn-download": "Download file",
    "files:tooltips:btn-delete": "Delete file",
    "files:tooltips:link-delete": "Delete link"
  }
}
</i18n>
